module.exports = __webpack_public_path__ + "static/b3b591c7-2da7-42c4-b210-fcc56ea9618c-54ebaff6c1e21356da6da82d383d7142.jpeg";